export default "__VITE_ASSET__50905883__"